<template>
  <list-grid
    :list-items="sheets"
    :disabled="disabledC"
    @displayDis="$emit('displayDis')"
  >
    <template #header>
      <div class="col-span-8 lg:col-span-4 ml-12">
        Nom
      </div>
      <div class="hidden lg:inline-block col-span-2">
        Secteur et famille
      </div>
      <div class="hidden lg:inline-block col-span-1">
        Ressource
      </div>
      <div class="hidden lg:inline-block col-span-2">
        Actions rapides
      </div>
      <div
        :id="personalLibrary ? 'edit-desc' : 'add-desc'"
        class="col-span-4 lg:col-span-3 truncate"
        @mouseover="addToLibraryToolTip = true"
        @mouseleave="addToLibraryToolTip = false"
      >
        <info-bulle-hover
          :is-display-tooltip="
            addToLibraryToolTip && !personalLibrary
          "
          name="addToMyLibrary"
          libelle="Ajouter à ma bibliothèque personnelle"
        />
        {{ actionColumnTitle() }}
      </div>
    </template>
    <template #accordionDescription="{item, num}">
      <div class="col-span-8 lg:col-span-4 ml-12 text-lg text-gray-900">
        {{ item.name }}
      </div>
      
      <div
        class="hidden lg:inline-block text-sm italic text-gray-600 col-span-2"
      >
        {{ item.data.sector }} <br>
        {{ item.data.family }}
      </div>
      
      <div class="hidden lg:inline-block col-span-1">
        <tag
          :libelle="tagStyle(item).label"
          :theme-color="tagStyle(item).color"
          text-size="text-sm"
          text-font="font-light"
        />
      </div>
      
      <SheetQuickActions
        :disabled="disabledC(item)"
        :type="item.type"
        :can-export="permissions.persoExport"
        :can-delete="permissions.persoDelete && personalLibrary"
        :can-dupe="permissions.persoAddNew && personalLibrary"
        :used-in-eval="item.is_used_in_evaluation"
        @showSheet="(editMode) => $emit('showSheet', [item, editMode])"
        @export="$emit('export', item)"
        @delete="$emit('delete', item)"
        @duplicate="$emit('duplicate', item)"
      />

      <SheetAction
        :disabled="disabledC(item)"
        :can-edit="permissions.persoEdit && personalLibrary"
        :can-import="permissions.commonAddToPerso && !personalLibrary"
        :can-view="permissions.persoRead && personalLibrary"
        :personal-library="personalLibrary"
        :type="item.type"
        :used-in-eval="item.is_used_in_evaluation"
        @edit="$emit('showSheet', [item, true])"
        @show="$emit('showSheet', [item, false])"
        @import="$emit('import', item)"
      />
    </template>
  </list-grid>
</template>
<script>
import ListGrid from '../components/AccordionTable/ListGrid.vue';
import InfoBulleHover from '../components/InfoBulleHover.vue';
import Tag from '../components/Tag.vue';
import Constants from '../constants';
import SheetQuickActions from './SheetQuickActions.vue';
import SheetAction from './SheetAction.vue';

export default {
  components: {SheetAction, SheetQuickActions, Tag, InfoBulleHover, ListGrid},
  props: {
    sheets: {
      type: Array,
      required: true
    },
    personalLibrary: {
      type: Boolean,
      required: true
    },
  },
  data: () => {
    return {
      addToLibraryToolTip: false,
    };
  },

  methods: {
    disabledC(sheet) {
      return sheet.type !== 'rome' && this.disabled;
    },

    actionColumnTitle() {
      if (this.personalLibrary) {
        let verb = this.permissions.persoEdit ? 'Modifier ' : 'Visualiser ';
        let subject = this.isJobDescriptionType ? 'la fiche' : 'le référentiel';
        return verb + subject;
      } else {
        return 'Ajouter à ma bibli.';
      }
    },

    tagStyle(sheet) {
      const neopassTypeSheet = ['job_desc', 'sheet', 'ref_formation'].includes(
        sheet.type
      );
      return {
        label: neopassTypeSheet ? 'Neopass' : 'Rome',
        color: neopassTypeSheet ? 'pink' : 'indigo',
      };
    },
  },

  computed: {
    disabled() {
      return !this.$subscribed() && !this.personalLibrary;
    },

    isJobDescriptionType() {
      return this.$route.name === 'JobDescription';
    },

    permissions() {

      return {
        persoEdit:
          (this.isJobDescriptionType &&
            this.$can(
              Constants.PERMISSION_FICHE_DE_POSTE_PERSONNELLE_EDITER
            )) ||
          (!this.isJobDescriptionType &&
            this.$can(
              Constants.PERMISSION_REFERENTIEL_FORMATION_PERSONNELLE_EDITER
            )),
        persoList:
          (this.isJobDescriptionType &&
            this.$can(Constants.PERMISSION_FICHE_DE_POSTE_PERSONNELLE_LISTE)) ||
          (!this.isJobDescriptionType &&
            this.$can(
              Constants.PERMISSION_REFERENTIEL_FORMATION_PERSONNELLE_LISTE
            )),
        commonList:
          (this.isJobDescriptionType &&
            this.$can(Constants.PERMISSION_FICHE_DE_POSTE_COMMUNE_LISTE)) ||
          (!this.isJobDescriptionType &&
            this.$can(
              Constants.PERMISSION_REFERENTIEL_FORMATION_COMMUNE_LISTE
            )),
        persoAddNew:
          (this.isJobDescriptionType &&
            this.$can(
              Constants.PERMISSION_FICHE_DE_POSTE_PERSONNELLE_AJOUTER_FICHE
            )) ||
          (!this.isJobDescriptionType &&
            this.$can(
              Constants.PERMISSION_REFERENTIEL_FORMATION_PERSONNELLE_AJOUTER_FICHE
            )),
        commonAddNew:
          (this.isJobDescriptionType &&
            this.$can(
              Constants.PERMISSION_FICHE_DE_POSTE_COMMUNE_AJOUTER_FICHE
            )) ||
          (!this.isJobDescriptionType &&
            this.$can(
              Constants.PERMISSION_REFERENTIEL_FORMATION_COMMUNE_AJOUTER_FICHE
            )),
        persoExport:
          (this.isJobDescriptionType &&
            this.$can(
              Constants.PERMISSION_FICHE_DE_POSTE_PERSONNELLE_EXPORTER
            )) ||
          (!this.isJobDescriptionType &&
            this.$can(
              Constants.PERMISSION_REFERENTIEL_FORMATION_PERSONNELLE_EXPORTER
            )),
        persoDelete:
          (this.isJobDescriptionType &&
            this.$can(
              Constants.PERMISSION_FICHE_DE_POSTE_PERSONNELLE_SUPPRIMER
            )) ||
          (!this.isJobDescriptionType &&
            this.$can(
              Constants.PERMISSION_REFERENTIEL_FORMATION_PERSONNELLE_SUPPRIMER
            )),
        persoRead:
          (this.isJobDescriptionType &&
            this.$can(
              Constants.PERMISSION_FICHE_DE_POSTE_PERSONNELLE_CONSULTER
            )) ||
          (!this.isJobDescriptionType &&
            this.$can(
              Constants.PERMISSION_REFERENTIEL_FORMATION_PERSONNELLE_CONSULTER
            )),
        persoDownloadModel:
          (this.isJobDescriptionType &&
            this.$can(
              Constants.PERMISSION_FICHE_DE_POSTE_PERSONNELLE_TELECHARGER_MODELE
            )) ||
          (!this.isJobDescriptionType &&
            this.$can(
              Constants.PERMISSION_REFERENTIEL_FORMATION_PERSONNELLE_TELECHARGER_MODELE
            )),
        persoDownloadInstructions:
          (this.isJobDescriptionType &&
            this.$can(
              Constants.PERMISSION_FICHE_DE_POSTE_PERSONNELLE_TELECHARGER_INSTRUCTIONS
            )) ||
          (!this.isJobDescriptionType &&
            this.$can(
              Constants.PERMISSION_REFERENTIEL_FORMATION_PERSONNELLE_TELECHARGER_INSTRUCTIONS
            )),
        commonExport:
          (this.isJobDescriptionType &&
            this.$can(Constants.PERMISSION_FICHE_DE_POSTE_COMMUNE_EXPORTER)) ||
          (!this.isJobDescriptionType &&
            this.$can(
              Constants.PERMISSION_REFERENTIEL_FORMATION_COMMUNE_EXPORTER
            )),
        commonDelete:
          (this.isJobDescriptionType &&
            this.$can(Constants.PERMISSION_FICHE_DE_POSTE_COMMUNE_SUPPRIMER)) ||
          (!this.isJobDescriptionType &&
            this.$can(
              Constants.PERMISSION_REFERENTIEL_FORMATION_COMMUNE_SUPPRIMER
            )),
        commonEdit:
          (this.isJobDescriptionType &&
            this.$can(Constants.PERMISSION_FICHE_DE_POSTE_COMMUNE_EDITER)) ||
          (!this.isJobDescriptionType &&
            this.$can(
              Constants.PERMISSION_REFERENTIEL_FORMATION_COMMUNE_EDITER
            )),
        commonRead:
          (this.isJobDescriptionType &&
            this.$can(Constants.PERMISSION_FICHE_DE_POSTE_COMMUNE_CONSULTER)) ||
          (!this.isJobDescriptionType &&
            this.$can(
              Constants.PERMISSION_REFERENTIEL_FORMATION_COMMUNE_CONSULTER
            )),
        commonAddToPerso:
          (this.isJobDescriptionType &&
            this.$can(
              Constants.PERMISSION_FICHE_DE_POSTE_COMMUNE_AJOUTER_DANS_BIBLIOTHEQUE_PERSONNELLE
            )) ||
          (!this.isJobDescriptionType &&
            this.$can(
              Constants.PERMISSION_REFERENTIEL_FORMATION_COMMUNE_AJOUTER_DANS_BIBLIOTHEQUE_PERSONNELLE
            )),
      };
    },
  }
};
</script>